import { CurrencyEnum } from "../models/enums/currency.enum";

export const CURRENCIES = [
  {
    id: CurrencyEnum.SEK,
    name: 'SEK'
  },
  {
    id: CurrencyEnum.EUR,
    name: 'EUR'
  }
];